module.exports = __webpack_public_path__ + "img/empty_pen.71e52ef8.svg";